
import React, { Component } from 'react';
import { Modal, Form, Input, TreeSelect, InputNumber} from 'antd';

import http from '../../../axios/http';

import DictSelect from '../../ui/DictSelect';

const FormItem = Form.Item;

class WechatMenuEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            const {editData} = this.props;
            values["level"] = editData.level;
            if(editData.state != null) {
                values["state"] = editData.state;
            }
            if(editData.id != null) {
                values["id"] = editData.id;
            }
            if (values["parentCode"]) {
                values["parentId"] = Number.parseInt(values["parentCode"]);
            }
            http.post({
                url: '/wx/menu/save',
                data: values,
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                }
            });
        });
    };

    render() {
        const { visible, onCancel, form, editData } = this.props;
        const { getFieldDecorator } = form;
        const {data} = this.props.orgTree();
        return (
            <Modal
                visible={visible}
                title="菜单编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <FormItem label="上级菜单：">
                        {getFieldDecorator('parentCode', {
                            initialValue: editData.parentCode
                        })(
                            <TreeSelect 
                                treeData={data} 
                                treeDefaultExpandAll={false}
                                allowClear={true}
                                showSearch={true}
                            />
                        )}
                    </FormItem>
                    <FormItem label="菜单类型：">
                        {getFieldDecorator('type', {
                            initialValue: editData.type==null? '':''+editData.type,
                        })(
                            <DictSelect category='WECHAT_MENU_TYPE' allowClear={true} />
                        )}
                    </FormItem>
                    <FormItem label="菜单名称：">
                        {getFieldDecorator('name', {
                            rules: [
                                { required: true, message: '请输入菜单名称!' },
                                { max: 16, message: '最多只能输入16个字符！' }],
                            initialValue: editData.name,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="链接：">
                        {getFieldDecorator('url', {
                            initialValue: editData.url,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="消息内容: ">
                        {getFieldDecorator('message', {
                            initialValue: editData.message,
                        })(
                            <Input.TextArea />
                        )}
                    </FormItem>
                    <FormItem label="小程序id：">
                        {getFieldDecorator('appid', {
                            initialValue: editData.appid,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="小程序页面路径：">
                        {getFieldDecorator('pagepath', {
                            initialValue: editData.pagepath,
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem label="显示顺序：">
                        {getFieldDecorator('sequence', {
                            rules: [
                                { required: true, message: '请输入显示顺序!' },
                            ],
                            initialValue: editData.sequence,
                        })(
                            <InputNumber min={0} max={10} style={{width:'100%'}}/>
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const WechatMenuEdit = Form.create()(WechatMenuEditForm);

export default WechatMenuEdit;